import { createTheme } from "@mui/material/styles";
import { defaultProps } from "./default-props-overrides";
import { overridesStyles } from "./overrides";
import { palette } from "./theme-options";
import { typography } from "./theme-options/typography";

export const theme = createTheme({
  typography,
  palette,
});

theme.components = {
  ...overridesStyles(theme),
  ...defaultProps(),
};
